module.exports = __webpack_public_path__ + "static/media/antigua-beaches-28.c616f211.jpg";